// src/components/Navbar.jsx
import React from 'react';

export default function Navbar() {
  return (
    <nav style={{
      background: '#fed875',
      position: 'sticky',
      top: 0,
      zIndex: 200,
      borderBottom: '1px solid rgba(91,20,179,0.12)',
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 clamp(24px, 4vw, 60px)',
        display: 'flex',
        alignItems: 'center',
        height: 56,
      }}>
        {/* Logo → homepage formuláře */}
        <a
          href="#"
          style={{
            display: 'flex', alignItems: 'center',
            textDecoration: 'none', lineHeight: 0,
          }}
        >
          <img
            src="/logo-purple.svg"
            alt="JIC"
            style={{ height: 22, display: 'block' }}
          />
        </a>
      </div>
    </nav>
  );
}
